module.exports = __webpack_public_path__ + "static/media/chili.b72bdbc0.svg";